<template>
  <div class="order-state-history">
    <perfect-scrollbar :options="{ suppressScrollX: true }">
      <div class="order-state-history__container">
        <loader v-if="loading" />
        <template v-else>
          <component
            :is="getItemComponent(item)"
            v-for="(item, key) in items"
            :key="key"
            :item="item"
          />
        </template>
      </div>
    </perfect-scrollbar>
  </div>
</template>

<script>
  import _ from 'lodash'
  import OrderStateHistoryType from '@/models/enums/OrderStateHistoryType'
  import SnackbarMessage from '@/mixins/snackbar-message'
  import OrderStateHistoryItem
    from '@/components/order-processing/order-components/history/order-state-history/OrderStateHistoryItem'
  import HistoryItemTypeCreate
    from '@/components/order-processing/order-components/history/order-state-history/items/HistoryItemTypeCreate'
  import HistoryItemTypeMenu
    from '@/components/order-processing/order-components/history/order-state-history/items/HistoryItemTypeMenu'
  import HistoryItemDefault
    from '@/components/order-processing/order-components/history/order-state-history/items/HistoryItemDefault'
  import Loader from '@/components/loader/Loader'
  import { websocketService } from '@/services/WebsocketService'
  import { getOrderChannel } from '@/util/websocket-channels'
  import HistoryItemTypeStatus
    from '@/components/order-processing/order-components/history/order-state-history/items/HistoryItemTypeStatus'
  import HistoryItemTypeFilial
    from '@/components/order-processing/order-components/history/order-state-history/items/HistoryItemTypeFilial'
  import HistoryItemTypePromocode
    from '@/components/order-processing/order-components/history/order-state-history/items/HistoryItemTypePromocode'
  import HistoryItemTypePayment
    from '@/components/order-processing/order-components/history/order-state-history/items/HistoryItemTypePayment'
  import HistoryItemTypeDelivery
    from '@/components/order-processing/order-components/history/order-state-history/items/HistoryItemTypeDelivery'
  import HistoryItemTypePreorder
    from '@/components/order-processing/order-components/history/order-state-history/items/HistoryItemTypePreorder'
  import HistoryItemTypeAssemblyComment
    from '@/components/order-processing/order-components/history/order-state-history/items/HistoryItemTypeAssemblyComment'
  import HistoryItemTypeCourierComment
    from '@/components/order-processing/order-components/history/order-state-history/items/HistoryItemTypeCourierComment'
  import HistoryItemTypeComplete
    from '@/components/order-processing/order-components/history/order-state-history/items/HistoryItemTypeComplete'
  import HistoryItemTypeCancel
    from '@/components/order-processing/order-components/history/order-state-history/items/HistoryItemTypeCancel'
  import HistoryItemTypeCall from './items/HistoryItemTypeCall.vue'
  import HistoryItemTypePaymentCancel from './items/HistoryItemTypePaymentCancel.vue'
  import HistoryItemTypeOrderPaid from './items/HistoryItemTypeOrderPaid.vue'

  export default {
    name: 'OrderStateHistory',
    components: { HistoryItemTypeMenu, Loader, OrderStateHistoryItem },
    mixins: [SnackbarMessage],
    props: {
      orderId: [String, Number],
    },
    data () {
      return {
        loading: true,
        items: [],
      }
    },
    async created () {
      this.loading = true
      try {
        this.items = await this.$store.dispatch('orders/fetchOrderStateLog', this.orderId)
      } catch (err) {
        this.showErrorFromResponse(err)
      }
      this.loading = false

      websocketService.listenEvent(
        getOrderChannel(this.orderId),
        'Order\\UpdateOrder',
        this.updateLogItems,
      )
    },
    beforeDestroy () {
      websocketService.stopListening(
        getOrderChannel(this.orderId),
        'Order\\UpdateOrder',
        this.updateLogItems,
      )
    },
    methods: {
      getItemComponent (item) {
        switch (item.type) {
          case OrderStateHistoryType.Create: return HistoryItemTypeCreate
          case OrderStateHistoryType.Status: return HistoryItemTypeStatus
          case OrderStateHistoryType.Menu: return HistoryItemTypeMenu
          case OrderStateHistoryType.Filial: return HistoryItemTypeFilial
          case OrderStateHistoryType.Promocode: return HistoryItemTypePromocode
          case OrderStateHistoryType.PaymentType: return HistoryItemTypePayment
          case OrderStateHistoryType.DeliveryType: return HistoryItemTypeDelivery
          case OrderStateHistoryType.Preorder: return HistoryItemTypePreorder
          case OrderStateHistoryType.AssemblyComment: return HistoryItemTypeAssemblyComment
          case OrderStateHistoryType.CourierComment: return HistoryItemTypeCourierComment
          case OrderStateHistoryType.Complete: return HistoryItemTypeComplete
          case OrderStateHistoryType.Cancel: return HistoryItemTypeCancel
          case OrderStateHistoryType.Call: return HistoryItemTypeCall
          case OrderStateHistoryType.PaymentCancel: return HistoryItemTypePaymentCancel
          case OrderStateHistoryType.OrderPaid: return HistoryItemTypeOrderPaid

          default:
            return HistoryItemDefault
        }
      },
      updateLogItems: _.debounce(async function () {
        this.items = await this.$store.dispatch('orders/fetchOrderStateLog', this.orderId)
      }, 700),
    },
  }
</script>

<style lang="less" scoped>
.order-state-history {
  &__container {
    height: calc(100vh - 200px);
  }
}
</style>
